import { render, staticRenderFns } from "./emailInbox.vue?vue&type=template&id=084ce72d&"
import script from "./emailInbox.vue?vue&type=script&lang=js&"
export * from "./emailInbox.vue?vue&type=script&lang=js&"
import style0 from "./emailInbox.vue?vue&type=style&index=0&id=084ce72d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports